module.exports = __webpack_public_path__ + "static/LP_portrait-2fa36e4ba1163d64bcb558e3f9f43c84.png";